<div class="sentiment-analysis__details-metrics-row">
  <app-sentiment-details-key-metrics
    [actionableFeedback]="host.getDetailsActionableFeedback()"
    [positiveActionable]="host.getDetailsPositiveActionable()"
    [neutralActionable]="host.getDetailsNeutralActionable()"
    [negativeActionable]="host.getDetailsNegativeActionable()"
  ></app-sentiment-details-key-metrics>
</div>
<div class="sentiment-analysis__details-themes-wrap">
  <div class="sentiment-analysis__summary-row sentiment-analysis__summary-row--details-themes">
    <div class="sentiment-analysis__summary-col sentiment-analysis__summary-col--half">
      <app-sentiment-details-top-themes
        [themeBreakdown]="host.stats?.themeSentimentBreakdown ?? []"
        [subThemeBreakdown]="host.stats?.subThemeSentimentBreakdown ?? []"
        [themeLimit]="host.config.topThemesLimit"
        [subThemeLimitPerTheme]="host.config.topSubThemesPerThemeLimit"
        [showPositive]="true"
        [showNegative]="false"
      ></app-sentiment-details-top-themes>
    </div>
    <div class="sentiment-analysis__summary-col sentiment-analysis__summary-col--half">
      <app-sentiment-details-top-themes
        [themeBreakdown]="host.stats?.themeSentimentBreakdown ?? []"
        [subThemeBreakdown]="host.stats?.subThemeSentimentBreakdown ?? []"
        [themeLimit]="host.config.topThemesLimit"
        [subThemeLimitPerTheme]="host.config.topSubThemesPerThemeLimit"
        [showPositive]="false"
        [showNegative]="true"
      ></app-sentiment-details-top-themes>
    </div>
  </div>
</div>
<div class="sentiment-analysis__details-three-cards">
  <div class="sentiment-analysis__details-card">
    <app-sentiment-details-theme-breakup-bars
      [themeBreakdown]="host.stats?.themeSentimentBreakdown ?? []"
      [selectedThemeId]="host.detailsSubthemeSelectedThemeId"
      (themeInfoClick)="host.openThemeBreakupPanel($event)"
      (themeBarClick)="host.syncThemeToCards($event)"
      (selectedThemeHiddenByFilter)="host.onDetailsThemeHiddenBySuggestedFilter()"
    ></app-sentiment-details-theme-breakup-bars>
  </div>
  <div class="sentiment-analysis__details-card">
    <app-sentiment-details-subtheme-breakup
      [subThemeBreakdown]="host.stats?.subThemeSentimentBreakdown ?? []"
      [selectedThemeId]="host.detailsSubthemeSelectedThemeId"
      [selectedSubThemeId]="host.detailsTrendSubThemeId"
      (subThemeClick)="host.syncSubThemeToTrendCard($event)"
      (subThemeInfoClick)="host.openSubThemeBreakupPanel($event)"
      (selectedSubThemeHiddenByFilter)="host.onDetailsSubThemeHiddenBySuggestedFilter()"
    ></app-sentiment-details-subtheme-breakup>
  </div>
  <div class="sentiment-analysis__details-card">
    <app-sentiment-details-trend-cohort-card
      [activeTab]="host.detailsTrendCohortTab"
      [timePeriod]="host.detailsTimePeriod"
      [timePeriodOptions]="host.detailsTrendTimePeriodOptions"
      [cohortFilter]="host.detailsCohortCardDimension"
      [cohortFilterOptions]="host.cohortBreakdownDropdownOptions"
      (activeTabChange)="host.onTrendCohortTabChange($event)"
      (timePeriodChange)="host.detailsTimePeriod = $event; host.loadTrendData()"
      (cohortFilterChange)="host.onCohortFilterChangeFromCard($event)"
    >
      <ng-container *ngIf="host.detailsTrendCohortTab === 'trend'">
        <div
          *ngIf="!host.detailsTrendThemeId && !host.detailsTrendSubThemeId"
          class="sentiment-details-trend-cohort-placeholder"
        >
          Select a theme from Theme break-up to view trend data
        </div>
        <app-sentiment-details-trend-widget
          *ngIf="host.detailsTrendThemeId || host.detailsTrendSubThemeId"
          [trendData]="host.trendData"
          [loading]="host.trendLoading"
          [timePeriod]="host.detailsTimePeriod"
        ></app-sentiment-details-trend-widget>
      </ng-container>
      <ng-container *ngIf="host.detailsTrendCohortTab === 'cohort'">
        <div
          *ngIf="!host.detailsTrendThemeId && !host.detailsTrendSubThemeId"
          class="sentiment-details-trend-cohort-placeholder sentiment-details-trend-cohort-placeholder--cohort"
        >
          <p>
            Select a theme from the Theme break-up card or a sub-theme from the Sub-theme break-up card to view
            cohort-wise break-up.
          </p>
        </div>
        <div
          *ngIf="(host.detailsTrendThemeId || host.detailsTrendSubThemeId) && host.cohortCardTableLoading"
          class="sentiment-details-trend-cohort-placeholder sentiment-details-trend-cohort-placeholder--cohort"
        >
          <p>Loading cohort data...</p>
        </div>
        <div
          *ngIf="
            (host.detailsTrendThemeId || host.detailsTrendSubThemeId) &&
            !host.cohortCardTableLoading &&
            host.cohortCardTableData.length
          "
          class="sentiment-details-cohort-card-data"
        >
          <div
            class="sentiment-details-cohort-table-wrap"
            [class.sentiment-details-cohort-table-wrap--infinite]="false"
            (scroll)="host.onCohortCardScroll($event)"
          >
            <table class="sentiment-details-cohort-table">
              <thead>
                <tr>
                  <th class="sentiment-details-cohort-table__th">{{ host.getCohortCardDimensionLabel() }}</th>
                  <th class="sentiment-details-cohort-table__th">Positive mentions</th>
                  <th class="sentiment-details-cohort-table__th">Neutral mentions</th>
                  <th class="sentiment-details-cohort-table__th">Negative mentions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of host.cohortCardTableData" class="sentiment-details-cohort-table__row">
                  <td class="sentiment-details-cohort-table__td sentiment-details-cohort-table__td--cohort">
                    {{ row.name }}
                  </td>
                  <td class="sentiment-details-cohort-table__td">{{ row.positive | number }}</td>
                  <td class="sentiment-details-cohort-table__td">{{ row.neutral | number }}</td>
                  <td class="sentiment-details-cohort-table__td">{{ row.negative | number }}</td>
                </tr>
              </tbody>
            </table>
            <p *ngIf="host.cohortCardFeedbackLoadingMore" class="sentiment-details-cohort-loading-more">
              Loading more responses…
            </p>
          </div>
        </div>
        <div
          *ngIf="
            (host.detailsTrendThemeId || host.detailsTrendSubThemeId) &&
            !host.cohortCardTableLoading &&
            !host.cohortCardTableData.length
          "
          class="sentiment-details-trend-cohort-placeholder sentiment-details-trend-cohort-placeholder--cohort"
        >
          <p>No cohort data available for this selection.</p>
        </div>
      </ng-container>
    </app-sentiment-details-trend-cohort-card>
  </div>
</div>
<app-sentiment-details-heatmap-analysis
  *ngIf="host.config.features.showHeatmap"
  [levelFilter]="host.detailsHeatmapLevel === 'theme' ? 'Themes' : 'Sub-themes'"
  [themeFilterValue]="host.detailsHeatmapThemeId"
  [cohortFilterValue]="host.detailsHeatmapCohortType"
  [cohortFilterOptions]="host.heatmapCohortOptions"
  [sentimentMode]="host.detailsHeatmapSentimentType"
  [heatmapData]="host.heatmapData"
  [themes]="host.cachedHeatmapThemes"
  [selectedCell]="host.heatmapCellSelected"
  [feedbackList]="host.heatmapFeedbackList"
  [feedbackLoading]="host.heatmapFeedbackLoading"
  [feedbackLoadingMore]="host.heatmapFeedbackLoadingMore"
  [feedbackHasMore]="host.heatmapFeedbackHasMore"
  [showFeedLinkRedirect]="host.showSentimentFeedLinkRedirect"
  [showCohortFooter]="host.showSentimentCohortFooter"
  [showSelectThemeMessage]="host.detailsHeatmapLevel === 'subTheme' && !host.detailsHeatmapThemeId"
  (feedbackLoadMore)="host.onHeatmapFeedbackLoadMore()"
  (openFeedbackDetails)="host.showFeedDetails($event)"
  (levelFilterChange)="host.onHeatmapLevelFilterChange($event)"
  (themeFilterChange)="host.onHeatmapThemeFilterChange($event)"
  (cohortFilterChange)="host.onHeatmapCohortFilterChange($event)"
  (sentimentModeChange)="host.onHeatmapSentimentModeChange($event)"
  (backToThemes)="host.onHeatmapBackToThemes()"
>
  <div heatmap-table>
    <app-sentiment-details-heatmap-widget
      [heatmapData]="host.heatmapData"
      [cohortType]="host.detailsHeatmapCohortType"
      [cohortOptionList]="host.heatmapCohortOptions"
      [level]="host.detailsHeatmapLevel"
      [sentimentType]="host.detailsHeatmapSentimentType"
      [themeId]="host.detailsHeatmapThemeId"
      [selectedCell]="host.heatmapCellSelected"
      [loading]="host.heatmapLoading"
      [hideHeader]="true"
      (cohortTypeChange)="host.detailsHeatmapCohortType = $event"
      (levelChange)="host.detailsHeatmapLevel = $event"
      (sentimentTypeChange)="host.detailsHeatmapSentimentType = $event"
      (themeIdChange)="host.detailsHeatmapThemeId = $event"
      (loadHeatmap)="host.loadHeatmapData()"
      (cellClick)="host.onHeatmapCellClick($event)"
      (rowClick)="host.onHeatmapCellClick($event)"
    ></app-sentiment-details-heatmap-widget>
  </div>
</app-sentiment-details-heatmap-analysis>
